import React, { useState } from "react";
import { Modal, Button, Form, Space, Steps, Result, Empty, Alert } from "antd";
import { useStepsForm } from "sunflower-antd";

import NutunPaymentInfo from "../PaymentType/NutunPaymentInfo";

import NupayPaymentInfo from "../PaymentType/NupayPaymentInfo";
import PayAtPaymentInfo from "../PaymentType/Pay@PaymentInfo";

const { Step } = Steps;

interface IModalProps {
  show: boolean;
  payment: any;
  showModal: Function;
  handleEdit: Function;
  memberId: string;
}

interface CardDataItem {
  CoveredName: string;
  CoveredSurname: string;
  CoveredIdNumber: string;
}

const resolvePaymentProvider = (payment: any): string | null => {
  if (!payment || typeof payment !== "object") return null;

  const hasPaymentInfo =
    payment.id ||
    payment.AccountNumber ||
    payment.PayAtAccountNumber ||
    payment.AccountName ||
    payment.Type;

  if (!hasPaymentInfo) return null;

  const provider = payment.Provider || payment.PaymentProvider;
  if (
    provider === "Nutun" ||
    provider === "Nupay" ||
    provider === "PayAt" ||
    provider === "Cash"
  ) {
    return provider;
  }

  if (payment.Type === "Cash") {
    return "Cash";
  }

  if (payment.Type === "PayAt" || payment.PayAtAccountNumber) {
    return "PayAt";
  }

  // DebiCheck mandates currently use Nupay (Nutun is on hold)
  if (payment.Type === "DebiCheck") {
    return "Nupay";
  }

  return null;
};

const EditPaymentMethodModal: React.FC<IModalProps> = ({
  show,
  payment,
  showModal,
  handleEdit,
  memberId,
}) => {
  const [formValues, setFormValues] = useState({});
  const [cardData, setCardData] = useState<CardDataItem[]>([]);
  const [loading, setLoading] = useState(false);

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    defaultFormValues: payment,
    async submit(values: any) {
      console.log(values);
      // if (values.Type === "DebiCheck") {
      //   const memberApiResponse = await getMemberApi(String(memberId));

      //   if (!memberApiResponse.success) {
      //     return false;
      //   }

      //   const response = await handleEdit(
      //     memberApiResponse.data.PaymentTypeID,
      //     { ...values, PaymentStatus: "Active", MandateAccepted: true }
      //   );

      //   if (response.success) {
      //     console.log(response);
      //     return true;
      //   }
      // } else {
      //   // const response = await handleAdd(memberId, values.Type, values);
      //   // if (response.success) {
      //   //   return true;
      //   // }
      // }
      return true;
    },
    total: 3,
  });

  // Step Styling
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 14 },
  };

  const paymentProvider = resolvePaymentProvider(payment);

  const getPaymentComponent = (provider: string | null) => {
    if (!provider) {
      return (
        <Empty
          description="No payment information available for this member."
          style={{ margin: "24px 0" }}
        />
      );
    }

    switch (provider) {
      case "Nutun":
        return (
          <NutunPaymentInfo
            buttonLoading={loading}
            gotoStep={gotoStep}
            form={form}
            update={false}
            submit={submit}
            memberId={memberId}
          />
        );
      case "Nupay":
        return (
          <NupayPaymentInfo
            buttonLoading={loading}
            gotoStep={gotoStep}
            form={form}
            update={false}
            submit={submit}
            memberId={memberId}
          />
        );
      case "PayAt":
        return (
          <PayAtPaymentInfo
            buttonLoading={loading}
            gotoStep={gotoStep}
            form={form}
            update={false}
            submit={submit}
            memberId={memberId}
          />
        );
      case "Cash":
        return (
          <>
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              message="Cash payer"
              description="This member is recorded as a Cash payer. There are no bank mandate details to edit. You can record cash receipts from the Payments tab."
            />
            <Form.Item
              labelCol={{ span: 8 }}
              wrapperCol={{ offset: 8, span: 8 }}
            >
              <Button block size="large" onClick={handleModal}>
                Close
              </Button>
            </Form.Item>
          </>
        );
      default:
        return (
          <Empty
            description="No payment information available for this member."
            style={{ margin: "24px 0" }}
          />
        );
    }
  };

  const display: any = [getPaymentComponent(paymentProvider)];

  return (
    <Modal
      title="Edit Payment Method"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={1100}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        {current === 1 && <></>}
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 1100 }}>
            {display[current]}
          </Form>

          {current === 2 && (
            <Result status="success" title="Successfully submitted">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 3 && (
            <Result status="error" title="Error occurred, please try again.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EditPaymentMethodModal;
